import React, { useState } from 'react'
import { router } from '@inertiajs/react'
import {
  Alert,
  Box,
  Button,
  Container,
  Link as MuiLink,
  Paper,
  TextField,
  Typography,
} from '@mui/material'

export default function TwoFactorChallenge({ method = 'totp', flash = {} }) {
  const [code, setCode] = useState('')
  const [useBackup, setUseBackup] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const isEmail = method === 'email'

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmitting(true)
    router.post(
      '/two_factor/challenge',
      { code, backup: useBackup },
      { onFinish: () => setSubmitting(false) }
    )
  }

  const handleResend = (e) => {
    e.preventDefault()
    router.post('/two_factor/challenge/resend', {})
  }

  const handleCancel = (e) => {
    e.preventDefault()
    router.delete('/two_factor/challenge')
  }

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h5" component="h1" fontWeight={700} gutterBottom>
          Zwei-Faktor-Authentifizierung
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
          {isEmail
            ? 'Wir haben Ihnen einen Code per E-Mail gesendet.'
            : useBackup
              ? 'Geben Sie einen Ihrer Backup-Codes ein.'
              : 'Geben Sie den Code aus Ihrer Authenticator-App ein.'}
        </Typography>

        {flash.alert && (
          <Alert severity="error" sx={{ width: '100%', mb: 2 }} data-testid="tfa-flash-alert">
            {flash.alert}
          </Alert>
        )}
        {flash.notice && (
          <Alert severity="success" sx={{ width: '100%', mb: 2 }} data-testid="tfa-flash-notice">
            {flash.notice}
          </Alert>
        )}

        <Paper elevation={2} sx={{ p: 4, width: '100%' }}>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              label={useBackup ? 'Backup-Code' : 'Code'}
              fullWidth
              margin="normal"
              autoFocus
              autoComplete="one-time-code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              slotProps={{ htmlInput: { 'data-testid': 'tfa-code-input', inputMode: useBackup ? 'text' : 'numeric' } }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={submitting || code.trim().length === 0}
              sx={{ mt: 2, mb: 2 }}
              data-testid="tfa-submit-button"
            >
              {submitting ? 'Prüfen...' : 'Bestätigen'}
            </Button>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
              {isEmail && (
                <MuiLink href="#" onClick={handleResend} variant="body2" underline="hover" data-testid="tfa-resend-link">
                  Code erneut senden
                </MuiLink>
              )}
              {!isEmail && (
                <MuiLink
                  href="#"
                  onClick={(e) => { e.preventDefault(); setUseBackup(!useBackup); setCode('') }}
                  variant="body2"
                  underline="hover"
                  data-testid="tfa-toggle-backup-link"
                >
                  {useBackup ? 'Authenticator-Code verwenden' : 'Backup-Code verwenden'}
                </MuiLink>
              )}
              <MuiLink href="#" onClick={handleCancel} variant="body2" underline="hover" color="text.secondary" data-testid="tfa-cancel-link">
                Abbrechen
              </MuiLink>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  )
}
